'use client'

import { useState, useEffect } from 'react'

export function useScrollDirection() {
  const [scrollDirection, setScrollDirection] = useState<'up' | 'down' | null>(null)
  const [lastScrollY, setLastScrollY] = useState(0)

  useEffect(() => {
    const updateScrollDirection = () => {
      const scrollY = window.pageYOffset
      const direction = scrollY > lastScrollY ? 'down' : 'up'
      
      // 스크롤이 5px 이상 움직였을 때만 업데이트 (민감도 조절)
      if (Math.abs(scrollY - lastScrollY) > 5) {
        setScrollDirection(direction)
        setLastScrollY(scrollY)
      }
    }

    window.addEventListener('scroll', updateScrollDirection)
    return () => {
      window.removeEventListener('scroll', updateScrollDirection)
    }
  }, [lastScrollY])

  return { scrollDirection, scrollY: lastScrollY }
}